import { computed } from 'vue'

export default computed(() => {
  return document.querySelector("meta[name=csrf-token]")?.getAttribute("content") || undefined
})
